import React, {useState} from 'react';
import Step1 from './step-1';
import Step2 from './step-2';
import Step3 from './step-3';
import SubSection from '../../../libs/react-components-admin/section/sub-section';
import Section from '../../../libs/react-components-admin/section/section';

const InstructionsForShopifyPageOsV2 = () => {

  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [createdPage, setCreatedPage] = useState();

  const steps = [
    {
      title: 'Step 1/3', component: <Step1 onDone={createdPage => {
        setCreatedPage(createdPage);
        setCurrentStepIndex(1);
      }}/>
    },
    {title: 'Step 2/3', component: <Step2 createdPage={createdPage}
                                          onPreviousClicked={() => setCurrentStepIndex(0)}
                                          onDone={() => setCurrentStepIndex(2)}/>},
    {title: 'Step 3/3', component: <Step3 onPreviousClicked={() => setCurrentStepIndex(1)}/>},
  ];

  return <Section title="Instructions">
    <div className="row justify-content-center">
      <div className="col-12 col-md-9">
        <SubSection title={steps[currentStepIndex].title} className="mb-5" noMargin={true}>
          {steps[currentStepIndex].component}
        </SubSection>
      </div>
    </div>
  </Section>;
};

export default InstructionsForShopifyPageOsV2;